export enum UserActionType {
  SETTINGS = 'settings',
  LOGOUT = 'logout'
}
